import { useEffect, useRef, useState } from 'react';
import { usePromotionEventGnbQuery } from '../api/promotion-event/hooks/usePromotionEventGnbQuery';
import newIcon from '../asset/svg/manual-new.svg';
import { usePreviousElementStore } from '../store/usePreviousElementStore';
import { getSubscriptionProducts } from '../utils/gtm/closer';
import { gtagViewItemListSubscriptionProduct } from '../utils/gtm/gtag';
import { MarketExhibitionGtm } from '../utils/gtm/market-exhibition/MarketExhibitionGtm';
import { MyPageGtm } from '../utils/gtm/mypage/myPageGtm';
import { PromotionGtmElement } from '../utils/gtm/promotion/promotion-gtm-element.enum';
import { UstoreGtm } from '../utils/gtm/ustore/ustoreGtm';
import PCHeaderMenuButton from './PCHeaderMenuButton';

function PCHeaderMenuList() {
  const [isLearn, setIsLearn] = useState(false);
  const { data: promotionEvents } = usePromotionEventGnbQuery();

  const onClickRecipes = () => {
    new MyPageGtm().click_community_menu();
  };

  const onClickSubscriptions = () => {
    getSubscriptionProducts()
      .then(gtagViewItemListSubscriptionProduct)
      .catch(console.error);
  };

  const onClickUstore = () => {
    const ustoreGtm = new UstoreGtm();
    ustoreGtm.click_ustore_menu();
  };

  const setPreviousElement = usePreviousElementStore.use.setPreviousElement();

  const onClickPromotionEvent = (exhibitionName: string) => {
    setPreviousElement(PromotionGtmElement.GNB);
    new MarketExhibitionGtm().click_market_exhibition_link({
      exhibition_name: exhibitionName,
      element: PromotionGtmElement.GNB,
    });
  };

  const el = useRef<HTMLDivElement>(null);

  const handleCloseModal = (e: MouseEvent) => {
    const dom = e.target as HTMLElement;
    if (isLearn && (!el.current || !el.current.contains(dom))) {
      setIsLearn(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleCloseModal);
    return () => {
      window.removeEventListener('click', handleCloseModal);
      if (isLearn) {
        setIsLearn(false);
      }
    };
  });

  return (
    <nav>
      <ul className="flex flex-row">
        <PCHeaderMenuButton
          name={'정기배송'}
          onClick={onClickSubscriptions}
          pathName={'/main'}
        />

        <PCHeaderMenuButton
          name={'마켓'}
          onClick={onClickUstore}
          pathName="/ustore"
        />

        <PCHeaderMenuButton
          name={'오늘 뭐 먹지'}
          onClick={onClickRecipes}
          pathName={'/recipes'}
        />
        <PCHeaderMenuButton
          name={'우리의 미션'}
          onClick={() => {}}
          pathName={'/mission'}
        />

        {promotionEvents?.map((event) => {
          const { globalNavBarName } = event;
          if (!globalNavBarName) return null;

          return (
            <PCHeaderMenuButton
              key={event.id}
              name={globalNavBarName}
              onClick={() => onClickPromotionEvent(globalNavBarName)}
              pathName={`/promotion-event/${event.slug}`}
              rightEl={
                <img
                  src={newIcon.src}
                  className="animate-blink w-11px h-11px"
                  alt={globalNavBarName}
                />
              }
            />
          );
        })}
      </ul>
    </nav>
  );
}

export default PCHeaderMenuList;
